// extracted by mini-css-extract-plugin
export default {"card":"hQ-z","defaultCard":"iQ-z","cardDetails":"jQ-z","cardActions":"kQ-z","separator":"lQ-z"};